/* Copyright 2013 - 2024 Waiterio LLC */
import React from 'react'
import { Navigate, useLocation } from 'react-router'
import slugs from '../slugs.js'

export const paths = Object.keys(slugs).map(locale => {
  const slug = slugs[locale]
  return {
    path: `/docs/${locale}/${slug}/`,
    props: {
      locale,
    },
  }
})

const DocsSlugRedirect = ({ locale }) => {
  let location = useLocation()
  let querystring = location.search
  return <Navigate exact to={`/docs/${locale}/${querystring}`} />
}

export default DocsSlugRedirect
